interface EnvConfig {
  API_BASE_URL: string;
  APP_NAME: string;
  APP_VERSION: string;
  EXPLORER_URL: string;
  ENABLE_DEVTOOLS: boolean;
  POLLING_INTERVAL: number;
  TOKEN_REFRESH_INTERVAL: number;
}

const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = import.meta.env[key] || defaultValue;
  if (!value && !defaultValue) {
    throw new Error(`Переменная окружения ${key} не определена`);
  }
  return value;
};

const getBooleanEnv = (key: string, defaultValue: boolean = false): boolean => {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  return value === 'true' || value === '1';
};

const getNumberEnv = (key: string, defaultValue: number): number => {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};

export const env: EnvConfig = {
  API_BASE_URL: getEnvVar('VITE_API_BASE_URL', 'http://localhost:8000/api/v1'),
  APP_NAME: getEnvVar('VITE_APP_NAME', 'TronBox Payment Gateway'),
  APP_VERSION: getEnvVar('VITE_APP_VERSION', '1.0.0'),
  EXPLORER_URL: getEnvVar('VITE_EXPLORER_URL', 'https://tronscan.org/#/transaction/'),
  ENABLE_DEVTOOLS: getBooleanEnv('VITE_ENABLE_DEVTOOLS', true),
  POLLING_INTERVAL: getNumberEnv('VITE_POLLING_INTERVAL', 5000),
  TOKEN_REFRESH_INTERVAL: getNumberEnv('VITE_TOKEN_REFRESH_INTERVAL', 300000),
};

export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
